import { onMounted, ref, type Ref } from 'vue'

type ApplePaySessionLike = { canMakePayments?: () => boolean }

export function useApplePayAvailability(): Ref<boolean> {
    const available = ref(false)

    onMounted(() => {
        if (typeof window === 'undefined') return
        const session = (window as unknown as { ApplePaySession?: ApplePaySessionLike }).ApplePaySession
        available.value = session?.canMakePayments?.() === true
    })

    return available
}
